import { Avatar } from "antd"
import { useMemo } from "react";
import { getColorByLetter, getColorByObjectId } from "../common/helpers";
import dayjs from "dayjs";
import { DATE_FORMAT_DD_MM_YYYY_HH_mm_A } from "../constants/constants";
import AdminChatIcon from "./icons/AdminChatIcon";

interface Props {
    data: any
}
const DeliveredItem = (props: Props) => {
    const { data } = props;

    return (
        <div className='p-[10px] hover:bg-[#ECFDF3] rounded-[8px] cursor-pointer w-full'>
            <div className='flex gap-x-[12px]'>
                {
                    data?.user === "admin" ? (
                        <AdminChatIcon />
                    ) : (
                        <Avatar className="!w-[32px]" style={getColorByObjectId(data?.userId)}>{data?.userName?.charAt(0)?.toUpperCase()}</Avatar>
                    )
                }
                <div>
                    <p className='text-[12px] font-[500] mb-[4px] flex-1 capitalize'>{data?.userName}</p>
                    <p className='m-0 text-[#667085] text-[10px]'>{dayjs(data.date).format(DATE_FORMAT_DD_MM_YYYY_HH_mm_A)}</p>
                </div>

            </div>

        </div>

    )
}

export default DeliveredItem